import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {InvoiceCalculationComponent} from './invoiceCalculation.component';

const routes: Routes = [
    {
        path: '',
        component: InvoiceCalculationComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InvoiceCalculationRoutingModule {}
